export const getAccessTokenLocalStorage = () => {
  const token = localStorage.getItem("accessToken");
  return token;
};

export const setAccessTokenLocalStorage = (accessToken: string) => {
  return localStorage.setItem("accessToken", accessToken);
};

export const getRefreshTokenLocalStorage = () => {
  const token = localStorage.getItem("refreshToken");
  return token;
};

export const setRefreshTokenLocalStorage = (refreshToken: string) => {
  return localStorage.setItem("refreshToken", refreshToken);
};
